import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SxProps, useTheme } from '@mui/material/styles';
import { Link } from 'src/components/Link';
import { GradientTypography } from 'src/components/gradients/GradientTypography';
import { GradientIconButton } from 'src/components/gradients/GradientIconButton';
import Chip from '@mui/material/Chip';
import ChevronRight from '@mui/icons-material/ChevronRight';
export type SearchResultBaseProps = {
  href: string;
  image: JSX.Element | JSX.Element[];
  imageSx?: SxProps;
  header: string;
  headerSx?: SxProps;
  subHeader?: string;
  subHeaderColor?: string;
  description?: string;
  category: string;
  chevronColor?: string;
};
export function SearchResultBase({
  href,
  image,
  imageSx = {},
  header,
  headerSx = {},
  subHeader,
  subHeaderColor = 'primary.vertical',
  description,
  category,
  chevronColor = 'primary.horizontal',
}: SearchResultBaseProps) {
  const theme = useTheme();
  return (
    <Link href={href} sx={{ width: '100%', textDecoration: 'none' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          p: 2,
          '&:hover': { cursor: 'pointer' },
        }}
      >
        <Box sx={{ mr: 4, ...imageSx }}>{image}</Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            rowGap: 2,
            height: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: '100%',
              mb: 1,
              flexGrow: 1,
            }}
          >
            <Typography variant="subtitle2" sx={{ ...headerSx }}>
              {header}
            </Typography>
            {!!subHeader && (
              <GradientTypography
                variant="subtitle2"
                gradientColor={subHeaderColor}
                sx={{
                  textTransform: 'uppercase',
                }}
              >
                {subHeader}
              </GradientTypography>
            )}
          </Box>
          {description && (
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.secondary,
                ...theme.lineClamp(2),
              }}
            >
              {description}
            </Typography>
          )}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: '100%',
              mt: 2,
            }}
          >
            <Chip
              label={category}
              variant="outlined"
              sx={{ fontSize: 12, height: 20, boxShadow: 1 }}
            />
            {/*TODO: There was supposed to be another element here for review cards. */}
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <GradientIconButton
            gradientColor={chevronColor}
            IconComponent={ChevronRight}
            sx={{ width: 40, height: 40, p: 0 }}
          />
        </Box>
      </Box>
    </Link>
  );
}
